import type { Bytes } from "@pdfking/tfunc"

import type { PdfEngineOptions } from "../types/engine/PdfEngineOptions"

export const CreatePdfEngineDefaults = (
  config: Partial<PdfEngineOptions> = {}
): PdfEngineOptions => ({
  file_cache: "pdfengine",
  chunk_size: (1024 * 1024 * 30) as Bytes,
  unit_to_px: 1,
  stroke_width: 1,
  image_resolution: 300,
  scale_bleed: 0,
  ...config,
})
